// extracted by mini-css-extract-plugin
module.exports = {"root":"AspectRatio-module__root___t6X1n","wrapper":"AspectRatio-module__wrapper___KBENf","inner":"AspectRatio-module__inner___87Vbp"};